import { render, staticRenderFns } from "./messageAdmin.vue?vue&type=template&id=4a85463e&scoped=true&"
import script from "./messageAdmin.vue?vue&type=script&lang=js&"
export * from "./messageAdmin.vue?vue&type=script&lang=js&"
import style0 from "./messageAdmin.vue?vue&type=style&index=0&id=4a85463e&prod&lang=less&scoped=true&"
import style1 from "./messageAdmin.vue?vue&type=style&index=1&id=4a85463e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a85463e",
  null
  
)

export default component.exports